import { Injectable } from '@angular/core';
import { DsconfigService, RestConnService, StorageService } from '@services/services.module';
import { Observable } from 'rxjs';
import { ProjectData, ImputationsData } from '@components/calendar/calendar-day/calendar-day.model';
import { Constants } from '@app/constants/constants';

@Injectable()
export class ModalWeekService {
  private imputation_weekly: object;
  private get_imputation_weekly: object;
  private imputations: object;

  constructor(
    private dsConfig: DsconfigService,
    private storage: StorageService,
    private _res: RestConnService
  ) {
    this.get_imputation_weekly = {
      'get_imputation_weekly': dsConfig.getUrlBase() + '/ess/v1/employee/imputation/weekly'
    };
    this.imputation_weekly = {
      'imputation_weekly': dsConfig.getUrlBase() + '/ess/v1/employee/imputation/weekly'
    };
    this.imputations = {
      'imputations': dsConfig.getUrlBase() + '/ess/v1/imputation/list'
    };
  }

  getSelectedWeek(dateInit: string, dateEnd: string): Observable<any> {
    return this._res
      .get('get_imputation_weekly', { dateInit: dateInit, dateEnd: dateEnd, employeeId: this.storage.get('userDataStorage').employeeNumber },
        {
          collection: this.get_imputation_weekly
        }
      );
  }

  saveSelectedWeek(inputSaveEmployee: Array<ProjectData>): Observable<any> {
    return this._res
      .post('imputation_weekly', {...{ imputationsEmployee: inputSaveEmployee }, ...{
          name: this.storage.get(Constants.UserData.employeeName),
          email: this.storage.get(Constants.UserData.email),
          employeeNumber: this.storage.get(Constants.UserData.employeeNumber),
          profileId: this.storage.get(Constants.UserData.profileId)
        }},
          {
            collection: this.imputation_weekly
          }
      );
  }

  deleteSelectedImputation(inputationSelected: ImputationsData): Observable<any> {
    return this._res
      .post('imputations', {...{imputations: [inputationSelected.imputationId]}, ...{
        name: this.storage.get(Constants.UserData.employeeName),
        email: this.storage.get(Constants.UserData.email),
        employeeNumber: this.storage.get(Constants.UserData.employeeNumber),
        profileId: this.storage.get(Constants.UserData.profileId)
      }},
        {
          collection: this.imputations
        }
      );
  }
}
